import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getSelectionD1ConferencesData = (state, setState) => {
    const api = initApi(API_NAMES.MEET, state, setState);

    const url = `/OmeSelectionsMeet/NcaaChampionshipMeetConferences`;
    return api?.executeArray ? api.executeArray(url, 'GET') : null;
};

const SelectionsD1ConferencesData = {
  getSelectionD1ConferencesData
};

export default SelectionsD1ConferencesData;